import { useAuth } from 'wasp/client/auth';
import { FC, ReactNode, memo, useMemo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import CommonLayout from '../../components/layout/CommonLayout';
import '../admin-theme.css';
import { adminLayoutConfig } from './adminConfig';
import { isAdministrator } from '../../client/lib/platformRole';

interface Props {
  children?: ReactNode;
}

const AdminLayoutInner: FC<Props> = ({ children }) => {
  const { data: user } = useAuth();
  const location = useLocation();

  // All derived values before any early returns (rules of hooks)
  const shouldRemovePadding =
    location.pathname.startsWith('/admin/users') ||
    location.pathname.startsWith('/admin/organizations') ||
    location.pathname.startsWith('/admin/organization-types') ||
    location.pathname.startsWith('/admin/sections') ||
    location.pathname.startsWith('/admin/service-types') ||
    location.pathname.startsWith('/admin/service-definitions') ||
    location.pathname.startsWith('/admin/topic-types') ||
    location.pathname.startsWith('/admin/topics') ||
    location.pathname.startsWith('/admin/taxonomy/location-categories') ||
    location.pathname.startsWith('/admin/global-settings') ||
    location.pathname.startsWith('/admin/taxonomy/location-names') ||
    location.pathname.startsWith('/admin/canada') ||
    location.pathname === '/admin/permissions' ||
    location.pathname === '/admin/approvals' ||
    location.pathname === '/admin/recycle-bin';

  const config = useMemo(() => adminLayoutConfig, []);

  if (!user) return null;

  if (!isAdministrator(user)) {
    return <Navigate to='/' replace />;
  }

  return (
    <div className="admin-surface">
      <CommonLayout config={config} user={user}>
        <div className={`w-full ${shouldRemovePadding ? '' : 'px-6 py-4 md:px-8 md:py-6 2xl:px-10 2xl:py-8'}`}>
          {children}
        </div>
      </CommonLayout>
    </div>
  );
};

const AdminLayout: FC<Props> = memo(({ children }) => {
  return <AdminLayoutInner>{children}</AdminLayoutInner>;
});

AdminLayout.displayName = 'AdminLayout';

export default AdminLayout;



